import { flushSync } from 'react-dom'

import { ClearButton } from '../../internal/clearButton/ClearButton'

type Props = {
  /** Must reset the date inputs, e.g. by remounting them, so partially typed segments are dropped too. */
  onClear: () => void
}

/** Clear button for date inputs, revealed once any date segment has a value (also partially typed ones). */
export const DateClearButton = ({ onClear }: Props) => (
  <span
    className="contents"
    // Only reachable programmatically, e.g. a date range picker auto-advancing past its last segment.
    onFocus={(event) =>
      (event.currentTarget.nextElementSibling as HTMLElement | null)?.focus()
    }
  >
    <ClearButton
      className="hidden! group-has-[[role=spinbutton][aria-valuenow]]/clearable:inline-flex!"
      onClear={(event) => {
        const dateGroup = event.target.closest('[role="group"]')
        flushSync(onClear) // Remount synchronously since onClear bumps the dateFieldKey which triggers a batched up rerender that would've not completed before next line focus call.
        dateGroup?.querySelector<HTMLElement>('[role="spinbutton"]')?.focus()
      }}
    />
  </span>
)
